import MaskUtils from '@/modules/Mask/MaskUtils';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IBAccountFormatter extends Vue {

	formatAccount(account?: string): string {
		return account?.length === 20
			? MaskUtils.toFormattedAccount(account)
			: (account || '');
	}

}